import styled, { css } from 'styled-components';
import Icon from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import { ANWBBrandRefresh, ANWBDefault } from '@anwb/theme';
import Typography from '@anwb/typography';
import { getNotificationVariantStyles } from './helpers';
/**
 * There is no correct token available for this border width, a story is on the backlog to fix this.
 */
const BRAND_REFRESH_BORDER_WIDTH = 2;
export const notificationContainerStyles = ({ theme, $variant, }) => css `
	display: grid;
	grid-column-gap: ${pxToRem(theme.spacing['200'])};
	grid-row-gap: ${pxToRem(theme.spacing['100'])};
	grid-template-columns: min-content auto min-content;
	grid-template-rows: auto;
	margin-top: 0 !important;
	margin-bottom: ${pxToRem(theme.spacing[200])} !important;
	padding: ${pxToRem(theme.spacing['200'])};
	width: 100%;
	height: auto;

	${theme.name === ANWBDefault.name
    ? css `
				border: ${pxToRem(theme.borderWidth[2])} solid
					${theme.colors.informative.borderNotification};
				border-radius: ${pxToRem(theme.borderRadius.m)};
				grid-template-areas:
					'icon title close-button'
					'. content content';
		  `
    : css `
				grid-template-areas:
					'icon title close-button'
					'content content content';
		  `}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-top: 1.5rem;
		margin-bottom: ${pxToRem(theme.spacing[300])} !important;

		${theme.name === ANWBBrandRefresh.name &&
    css `
			border-left-width: ${pxToRem(BRAND_REFRESH_BORDER_WIDTH)};
			border-left-style: solid;
		`}
	}

	${getNotificationVariantStyles($variant)}
`;
export const NotificationContainer = styled.div `
	${notificationContainerStyles}
`;
/**
 * Notification Icon
 */
export const notificationIconStyles = ({ theme }) => css `
	display: flex;
	grid-area: icon;
	align-self: flex-start;
	line-height: ${pxToRem(theme.lineHeights['600'])};
`;
export const NotificationIcon = styled(Icon).attrs({
    size: 'xl',
}) `
	${notificationIconStyles}
`;
/**
 * Notification Title
 */
export const notificationTitleStyles = ({ theme }) => css `
	grid-area: title;
	margin-bottom: 0;

	${theme.name === ANWBBrandRefresh.name &&
    css `
		align-self: center;
	`}
`;
export const NotificationTitle = styled(Typography).attrs({
    variant: 'notification-title',
}) `
	${notificationTitleStyles}
`;
/**
 * Notification Close Button
 */
export const notificationCloseButtonStyles = ({ theme }) => css `
	padding: 0;
	border: none;
	border-radius: 0;
	background-color: transparent;
	&& {
		line-height: 1.2rem;
	}

	align-self: flex-start;
	color: ${theme.colors.highlight.iconInteractive};

	&:focus,
	&:hover {
		color: ${theme.colors.highlight.iconHover};
	}
`;
export const NotificationCloseButton = styled.button `
	${notificationCloseButtonStyles}
`;
/**
 * Notification Content
 */
export const notificationContentStyles = () => css `
	grid-area: content;

	* {
		font-size: inherit;
	}
`;
export const NotificationContent = styled(Typography).attrs({
    tagName: 'span',
}) `
	${notificationContentStyles}
`;
//# sourceMappingURL=notification.styled.js.map